<script setup lang="ts">
import { TagsInputRoot, type TagsInputRootEmits, type TagsInputRootProps, useForwardPropsEmits } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'
import { useColorMode } from '@/composables/src/useColorMode'
import { cn } from '@/foundation/utils'

const props = defineProps<TagsInputRootProps & { class?: HTMLAttributes['class'] }>()
const emits = defineEmits<TagsInputRootEmits>()
const { mode } = useColorMode()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <TagsInputRoot
    v-bind="forwarded"
    :class="[
      cn('flex flex-wrap gap-2 items-center rounded-xl border border-input px-3 py-2 text-sm', props.class),
      { 'bg-white': mode === 'light', 'bg-sidebar-accent': mode === 'dark' },
    ]"
  >
    <slot />
  </TagsInputRoot>
</template>
